import React from 'react';

const Report = () => {
    return (
        <div className='Text-5xl text-blue-400'>
                    This is Report 
        </div>
    );
};

export default Report;